/* eslint-disable react-hooks/exhaustive-deps */

import { FC, useMemo } from 'react';
import { FilterOptions } from '@zoopla/redux-types';

type PriceOptions = {
    options: FilterOptions;
    priceOtherInt: number;
    keyPrefix: string;
};

export const ForSalePriceMinSelectOptions: FC<
    React.PropsWithChildren<PriceOptions>
> = ({ options, priceOtherInt, keyPrefix }) =>
    useMemo(() => {
        const priceMaxInt = priceOtherInt;

        return (
            // see: https://github.com/yannickcr/eslint-plugin-react/issues/2584
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
                {options
                    ?.filter(
                        (priceMinOption) =>
                            priceMaxInt === 0 ||
                            priceMinOption === null ||
                            priceMaxInt >= parseInt(priceMinOption?.value)
                    )
                    ?.map((priceMinOption) => (
                        <option
                            key={`${keyPrefix}-${priceMinOption?.value}`}
                            value={priceMinOption?.value}
                        >
                            {priceMinOption?.label}
                        </option>
                    )) ?? []}
            </>
        );
    }, [priceOtherInt]);

export const ForSalePriceMaxSelectOptions: FC<
    React.PropsWithChildren<PriceOptions>
> = ({ options, priceOtherInt, keyPrefix }) =>
    useMemo(() => {
        const priceMinInt = priceOtherInt;
        return (
            // see: https://github.com/yannickcr/eslint-plugin-react/issues/2584
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
                {options
                    ?.filter(
                        (priceMaxOption) =>
                            priceMaxOption === null ||
                            priceMaxOption.value === '0' ||
                            priceMinInt <= parseInt(priceMaxOption?.value)
                    )
                    ?.map((priceMaxOption) => (
                        <option
                            key={`${keyPrefix}-${priceMaxOption?.value}`}
                            value={priceMaxOption?.value}
                        >
                            {priceMaxOption?.label}
                        </option>
                    )) ?? []}
            </>
        );
    }, [priceOtherInt]);

export const ToRentPriceMinSelectOptions: FC<
    React.PropsWithChildren<PriceOptions>
> = ({ options, priceOtherInt, keyPrefix }) =>
    useMemo(() => {
        const priceMaxInt = priceOtherInt;

        return (
            // see: https://github.com/yannickcr/eslint-plugin-react/issues/2584
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
                {options
                    ?.filter(
                        (priceMinOption) =>
                            priceOtherInt === 0 ||
                            priceMinOption === null ||
                            priceMaxInt >= parseInt(priceMinOption?.value)
                    )
                    ?.map((priceMinOption) => (
                        <option
                            key={`${keyPrefix}-${priceMinOption?.value}`}
                            value={priceMinOption?.value}
                        >
                            {priceMinOption?.label}
                        </option>
                    )) ?? []}
            </>
        );
    }, [priceOtherInt]);

export const ToRentPriceMaxSelectOptions: FC<
    React.PropsWithChildren<PriceOptions>
> = ({ options, priceOtherInt, keyPrefix }) =>
    useMemo(() => {
        const priceMinInt = priceOtherInt;

        return (
            // see: https://github.com/yannickcr/eslint-plugin-react/issues/2584
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
                {options
                    ?.filter(
                        (priceMaxOption) =>
                            priceMaxOption === null ||
                            priceMaxOption.value === '0' ||
                            priceMinInt <= parseInt(priceMaxOption?.value)
                    )
                    ?.map((priceMaxOption) => (
                        <option
                            key={`${keyPrefix}-${priceMaxOption?.value}`}
                            value={priceMaxOption?.value}
                        >
                            {priceMaxOption?.label}
                        </option>
                    )) ?? []}
            </>
        );
    }, [priceOtherInt]);
